import { apiWithdrawApply, apiWithdrawVerify } from '@/api/imee'
import _debounce from 'lodash/debounce'

export const applyMixin = {
  data() {
    return {
      applyFlag: false,
    }
  },
  methods: {
    checkWithdrawInfo: _debounce(
      function () {
        const data = {
          accountCfgId: this.cfgId,
          dollarsAmount: this.priceActive,
          withdrawalMethod: this.withdrawalMethod,
        }
        apiWithdrawVerify(data, this.walletType).then((res) => {
          if (res.status == 200) {
            this.showWithdrawConfirm()
          }
          //
          else {
            this.withdrawAccountNotFound = false

            if (res.error.status == 692 && this.walletType == 0) {
              this.showNoAuthDia = true
              return
            }

            if (res.error.status == 694) {
              this.titleConfirmUp = res.error.description
              this.showDiaUp = true
              return
            }

            if (res.error.status == 693) {
              this.withdrawAccountNotFound = true
            }

            this.headline = null
            this.con = res.error.description
            this.showDia = true
          }
        })
      },
      2000,
      {
        leading: true,
        trailing: false,
      }
    ),
    handleWithdrawApply() {
      if (this.applyFlag) {
        return
      }
      this.applyFlag = true
      apiWithdrawApply(
        {
          accountCfgId: this.cfgId,
          dollarsAmount: this.priceActive,
        },
        this.walletType
      )
        .then((res) => {
          if (res && res.error) {
            this.titleConfirm = res.error.description
            this.headline = null
            this.showDialog = false
            this.showDiaConfirm = true
          }
          if (res && res.status == 200) {
            this.showDialog = false
            this.showDiaConfirm = true
            this.fetchBaseInfo()
          }
          this.applyFlag = false
        })
        .finally(() => {
          this.applyFlag = false
        })
    },
  },
}
